import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInsights = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_113_9934)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_113_9934",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 25,
			children: /* @__PURE__ */ _jsx("rect", {
				y: .218994,
				width: 24,
				height: 24,
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_113_9934)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M5.79999 18.419V13.4113H8.39999V18.419H5.79999ZM10.7 18.419V6.01904H13.3V18.419H10.7ZM15.6 18.419V10.6268H18.2V18.419H15.6Z",
				fill: "currentColor"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_113_9934",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor",
			transform: "translate(0 0.218994)"
		})
	}) })]
});
export default SvgInsights;
